import { render, staticRenderFns } from "./ChemCPP1220LSBQ1.vue?vue&type=template&id=2efaf265&scoped=true&"
import script from "./ChemCPP1220LSBQ1.vue?vue&type=script&lang=js&"
export * from "./ChemCPP1220LSBQ1.vue?vue&type=script&lang=js&"
import style0 from "./ChemCPP1220LSBQ1.vue?vue&type=style&index=0&id=2efaf265&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2efaf265",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VForm,VTextField})
